import styled from 'styled-components';

export const styledCheckbox = (Component) => styled(Component)`
  color: var(--grey900);
  border: solid 1px var(--grey500);
  background: white;
  width: ${(props) => props.width};
  height: 32px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: var(--primary100);
    cursor: pointer;
  }

  &&.active {
    background-color: var(--primary100);
  }
`;
